/**
 * The four status tones shared by every status line (station library,
 * playlist strip, tile captions, confirm-sheet library line). D-14.
 */
export const TONE_CLASSES = {
  success: 'text-emerald-700 dark:text-emerald-400',
  warning: 'text-amber-700 dark:text-amber-400',
  error: 'text-red-600 dark:text-red-400',
  muted: 'text-gray-500 dark:text-gray-400',
};
